module.exports = __webpack_public_path__ + "static/media/assigBoomer.107c3c84.png";